export default "__VITE_ASSET__Cvjwo4ko__"